import { styled } from '@mui/system'
import { fontSizes, colors } from '../../../../Components/consts'


export const AccoladeStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: theme.spacing(1, 0),
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${colors.lightestGrey}`,
  '& .accoladeCol': {
    display: 'flex',
    flexDirection: 'column',
    '& .name': {
      fontSize: fontSizes.medium,
      color: colors.text,
      margin: theme.spacing(0, 0.25, 0.25),
      fontWeight: 'bold',
    },
    '& .yearCon': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      '& .years': {
        fontSize: fontSizes.small,
        color: colors.text,
        margin: theme.spacing(0, 0.25, 0.25),
        fontWeight: 500,
        [theme.breakpoints.down('sm')]: {
          fontWeight: 500,
          fontSize: 12,
        },
      },
    },
  },
  '& .accoladeCount': {
    fontSize: fontSizes.semiLarge,
    color: colors.text,
    margin: theme.spacing(0, 3, 0.25),
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: fontSizes.medium,
    },
  },
}))
